'use client'

import { IconChevronLeft } from "@tabler/icons-react";
import Link from "next/link";
import { ReactNode, useEffect, useState } from "react";
import NextLink from './NextLink';
import SmartBackButton from './SmartBackButton';
import { usePathname } from 'next/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faX } from '@fortawesome/pro-regular-svg-icons';
import HeaderSearch from './ui/HeaderSearch';
import { AnimatePresence, motion } from 'framer-motion';
import useSetSearchParams from '@/hooks/useSetSearchParams';

export default function MobileHeaderNavigation({ text, backUrl = '/', children, forceUrl = false }:
    { text?: string | ReactNode, backUrl: string, children?: ReactNode, forceUrl?: boolean }) {
    const [isSearchActive, setIsSearchActive] = useState(false)
    const [counter, setCounter] = useState(0)
    const pathname = usePathname()
    const { params: { blogSearch } } = useSetSearchParams()

    useEffect(()=> {
if (blogSearch) {
    setIsSearchActive(true)
}
    }, [blogSearch])

    return (
        <div className="flex  md:hidden overflow-hidden flex-row justify-between items-center z-50 bg-white shadow-md  mx-auto py-4 sticky w-full top-0 left-0 right-0">
            <div className='my-container'>
                <div className="grid grid-cols-[24px,_1fr,_24px] gap-1  w-full">
                    <SmartBackButton forceUrl={forceUrl} customUrl={backUrl}
                    >
                        <IconChevronLeft stroke={2} />
                    </SmartBackButton>
                    <div className='text-left relative '>
                        <AnimatePresence>

                            {isSearchActive &&
                                <motion.div
                                    key={counter}
                                    initial={{ opacity: 0, y: '-140%' }}
                                    exit={{ opacity: 0, y: '-140%' }}
                                    animate={{ opacity: 100, y: '-50%' }}
                                    className='absolute top-1/2 w-full -translate-y-1/2'>
                                    <HeaderSearch />
                                </motion.div>}
                            {!isSearchActive && <motion.div
                                key={counter}
                                initial={{ opacity: 0, y: '140%' }}
                                exit={{ opacity: 0, y: '140%' }}
                                animate={{ opacity: 100, y: '-50%' }}
                                className='absolute top-1/2 w-full -translate-y-1/2'>
                                {text}
                            </motion.div>

                            }
                        </AnimatePresence>
                    </div>
                    {pathname.includes('/blog') ?
                        isSearchActive ? <button onClick={() => {
                            setCounter(s => s + 1)
                            setIsSearchActive(false)
                        }}
                            className='aspect-square text-xs block h-full rounded-lg text-neutral-700'>
                            <FontAwesomeIcon icon={faX} />
                        </button> :
                            <button onClick={() => {
                                setCounter(s => s + 1)
                                setIsSearchActive(true)
                            }}
                                className='aspect-square text-xs block h-full rounded-lg bg-pink-gradient text-white'>
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        :
                        <span></span>}
                </div>
                {children}
            </div>
        </div>
    )
}